import * as tslib_1 from "tslib";
import { CollectionSwitch } from './collection_switch';
var CheckGroup = /** @class */ (function (_super) {
    tslib_1.__extends(CheckGroup, _super);
    function CheckGroup(param) {
        return _super.call(this, param) || this;
    }
    CheckGroup.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "CheckGroup" });
    };
    CheckGroup.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return CheckGroup;
}(CollectionSwitch));
export { CheckGroup };
//# sourceMappingURL=check_group.js.map